export const ParagraphRenderer = ({ text }) => {
  if (!text) return null; // or return <p>No content available</p>

  return text.split(/\n\s*\n/).map((para, index) => (
    <p key={index} className=" lg:text-xl md:text-lg ">
      {para}
    </p>
  ));
};
